import { render, staticRenderFns } from "./JsonGenerator.vue?vue&type=template&id=dea08800&scoped=true&"
import script from "./JsonGenerator.vue?vue&type=script&lang=js&"
export * from "./JsonGenerator.vue?vue&type=script&lang=js&"
import style0 from "./JsonGenerator.vue?vue&type=style&index=0&id=dea08800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea08800",
  null
  
)

export default component.exports